module.exports = __webpack_public_path__ + "static/media/dailystory.02f38fc3.png";